module.exports = __webpack_public_path__ + "img/header-img-2.7c9dec96.png";